import React, { ReactNode, useState } from 'react';
import styles from './index.less';
import { Collapse, CollapseProps } from 'antd';
import classNames from 'classnames';

interface DrawerSectionProps {
  title?: string | ReactNode;
  action?: ReactNode;
  children: ReactNode;
  sectionStyles?: React.CSSProperties;
  collapse?: boolean | CollapseProps;
  panelProps?: {
    extra?: ReactNode
  };
  className?: string;
}

const DrawerSection: React.FC<DrawerSectionProps> = ({
                                                       title,
                                                       children,
                                                       action,
                                                       sectionStyles,
                                                       collapse,
                                                       panelProps = {},
                                                       className = '',
                                                     }: DrawerSectionProps) => {

  const [activeKey, setActiveKey] = useState<string | string[]>([]);
  const titleContent = typeof title === 'string' ? <h2 className={styles.title}>{title}</h2> : (title || '');

  const handleOnChange = (key: string | string[]) => {
    setActiveKey(key);
    if (typeof collapse === 'object' && collapse.onChange) {
      collapse.onChange(key);
    }
  };

  if (collapse) {
    const collapseProps = typeof collapse === 'object' ? collapse : {};
    const currentActiveKey = (typeof collapse === 'object' && collapse.activeKey !== undefined)
      ? collapse.activeKey
      : activeKey;

    return <Collapse className={classNames(styles.drawerSection, styles.drawerSectionCollapse, className)}
                     activeKey={currentActiveKey}
                     onChange={handleOnChange}
                     style={sectionStyles}
                     {...collapseProps}
    >
      <Collapse.Panel key={'1'} header={titleContent} {...panelProps}>
        {children && children}
      </Collapse.Panel>
    </Collapse>;
  }

  return (
    <div className={styles.drawerSection} style={sectionStyles}>
      <div className={styles.header}>
        {titleContent}
        {action}
      </div>
      {children && children}
    </div>
  );
};

export default DrawerSection;
